export default {
    17: {
        typeName: "Merchant",
        town: true,
        names: ["Alfred","Barney","Calvin","Edmund","Edwin","Eugene","Finn","Frank","Frederick","Gilbert","Gus","Harold","Howard","Humphrey","Isaac","Joseph","Kristian","Louis","Milton","Mortimer","Ralph","Seymour","Walter","Wilbur"]
    },
    18: {
        typeName: "Nurse",
        town: true,
        names: ["Abigail","Allison","Amy","Caitlin","Carly","Claire","Emily","Emma","Hannah","Heather","Helen","Holly","Jenna","Kaitlin","Kaitlyn","Katelyn","Katherine","Kathryn","Katie","Kayla","Lisa","Lorraine","Madeline","Molly"]
    },
    19: {
        typeName: "Arms Dealer",
        town: true,
        names: ["DeShawn","DeAndre","Marquis","Darnell","Terrell","Malik","Trevon","Tyrone","Willie","Dominique","Demetrius","Reginald","Jamal","Maurice","Jalen","Darius","Xavier","Terrance","Andre","Dante","Brimst","Bronson","Tony","Darryl"]
    },
    20: {
        typeName: "Dryad",
        town: true,
        names: ["Alalia","Alura","Ariella","Caelia","Calista","Chryseis","Emerenta","Elysia","Evvie","Faye","Felicitae","Lunette","Nata","Nissa","Tatiana","Rosalva","Shea","Tania","Isis","Celestia","Xylia"]
    },
    22: {
        typeName: "Guide",
        town: true,
        names: ["Joe","Connor","Tanner","Wyatt","Cody","Levi","Luke","Jack","Scott","Logan","Cole","Asher","Bradley","Jacob","Garrett","Dylan","Maxwell","Steve","Brett","Andrew","Harley","Kyle","Jake","Ryan","Jeffrey","Seth","Mary","Brandon","Zach","Jeff","Daniel","Trent","Kevin","Brian","Colin"]
    },
    37: {
        typeName: "Old Man",
        town: true
    },
    38: {
        typeName: "Demolitionist",
        town: true,
        names: ["Dolbere","Bazdin","Durim","Tordak","Garval","Morthal","Oten","Dolgen","Gimli","Gimut","Duerthen","Beldin","Jarut","Ovbere","Norkas","Dolgrim","Boften","Norsun","Dias","Fikod","Urist","Darur"]
    },
    54: {
        typeName: "Clothier",
        town: true,
        names: ["Sebastian","Rupert","Clive","Nigel","Mervyn","Cedric","Pip","Cyril","Fitz","Lloyd","Arthur","Rodney","Graham","Edward","Alfred","Edmund","Henry","Herald","Roland","Lincoln","Lloyd","Edgar","Eustace","Benjamin","James","Rodrick"]
    },
    107: {
        typeName: "Goblin Tinkerer",
        town: true,
        names: ["Grodax","Sarx","Xon","Mrunok","Nuxatk","Tgerd","Darz","Smador","Stazen","Mobart","Knogs","Tkanus","Negurk","Nort","Durnok","Trogem","Stezom","Gnudar","Ragz","Fahd","Xanos","Arback","Fjell","Dalek","Knub"]
    },
    108: {
        typeName: "Wizard",
        town: true,
        names: ["Dalamar","Dulais","Elric","Arddun","Maelor","Leomund","Hirael","Gwentor","Greum","Gearroid","Fizban","Ningauble","Seonag","Sargon","Merlyn","Magius","Berwyn","Arwyn","Alasdair","Tagar","Abram","Xanadu"]
    },
    124: {
        typeName: "Mechanic",
        town: true,
        names: ["Shayna","Korrie","Ginger","Brooke","Jenny","Autumn","Nancy","Ella","Kayla","Selah","Sophia","Marshanna","Lauren","Trisha","Shirlena","Sheena","Ellen","Amy","Dawn","Susana","Meredith","Selene","Terra","Sally"]
    },
    142: {
        typeName: "Santa Claus",
        town: true
    },
    160: {
        typeName: "Truffle",
        town: true,
        names: ["Reishi","Maitake","Chanterelle","Porcini","Shimeji","Amanita","Muscaria","Agaric","Cremini","Morel","Enoki","Shiitake"]
    },
    178: {
        typeName: "Steampunker",
        town: true,
        names: ["Whitney","Verity","Ada","Cornelia","Lydia","Leila","Minerva","Emeline","Cynthia","Fidelia","Lilly","Phoebe","Zylphia","Zelda","Selina","Hope","Isabella","Judith","Savannah","Vivian"]
    },
    207: {
        typeName: "Dye Trader",
        town: true,
        names: ["Abdosir","Akbar","Bodashtart","Danel","Hanno","Hiram","Kanmi","Philosir","Tabnit","Yutpan","Ahirom","Batnoam","Sikarbaal","Hannibal","Yehomilk","Ahinadab"]
    },
    208: {
        typeName: "Party Girl",
        town: true,
        names: ["Candy","Isis","Trixy","Destiny","Lexus","Bambi","Bailey","Glitter","Sparkle","Paris","Dazzle","Fantasy","Bunny","Sugar","Fantasia","Star","Cherry"]
    },
    209: {
        typeName: "Cyborg",
        town: true,
        names: ["Alpha","Beta","Delta","Omega","Gamma","Theta","Kappa","Omicron","Sigma","Upsilon","Phi","Zeta","Lambda","Nu","Ci","Rho","Phi","Fender","T-3E0","Niner-7","A.N.D.Y","Syn-X","Mu"]
    },
    227: {
        typeName: "Painter",
        town: true,
        names: ["Marco","Guido","Enzo","Martino","Mauro","Lorenzo","Ludo","Luciano","Carlo","Bruno","Mario","Leonardo","Raphael","Luigi","Luca","Darren","Esreadel","Stefano"]
    },
    228: {
        typeName: "Witch Doctor",
        town: true,
        names: ["Abibe","Jamundi","U'wa","Tairona","Xirigua","Zop'a","Opuni","Kogi-ghi","Konah","Gboto"]
    },
    229: {
        typeName: "Pirate",
        town: true,
        names: ["David","Red Beard","Jack","Black Beard","Captain Morgan","Wet Beard","James T. Beard","Gunpowder Garry","Captain Stoney Dirt","Jake","Captain Bullywort"]
    },
    353: {
        typeName: "Stylist",
        town: true,
        names: ["Bri","Brianne","Flora","Iris","Scarlett","Lola","Hazel","Stella","Pearl","Tallulah","Ruby","Esmeralda","Kylie","Kati","Biah","Meliyah","Petra","Rox","Roxanne","Annabel"]
    },
    368: {
        typeName: "Traveling Merchant",
        town: true,
        names: ["Abraham","Bohemas","Eladon","Aphraim","Gallius","Llewellyn","Riley","Rawleigh","Shipton","Romeo","Aedan","Mercer","Willy"]
    },
    369: {
        typeName: "Angler",
        town: true,
        names: ["Bobby","Sammy","Jimmy","Danny","Timmy","Simon","Johnny","Billy","Matty","Bart","Phillip","Spencer","Nathan","Grayson","Miles","Charles","Adam","Tyler","Jey","Ivan","Izzy"]
    },
    441: {
        typeName: "Tax Collector",
        town: true,
        names: ["McKinly","Millard","Fillmore","Rutherford","Chester","Grover","Cleveland","Theodore","Herbert","Warren","Lyndon","Ronald","Harrison","Woodrow","Tweed","Blanton","Dwyer","Carroll","Agnew"]
    },
    453: {
        typeName: "Skeleton Merchant",
        names: ["Skellington","Bones McGee","Gloomy Mays","Jack Sellington","Billy Marrows","Tom","Rattles Magoo","Mandible Calavera","Mika","No-Eyed Wiley"]
    },
    550: {
        typeName: "Tavernkeep",
        town: true,
        names: ["Ted","Barkeep","Jerry","Bill","Ernest","William","Dale","Bruce","Moe","Javahawk","Elandrian","Driscan","Iamisom","Blacksmith","Dani Moo","Paddy"]
    },
    588: {
        typeName: "Golfer",
        town: true,
        names: ["Lion Pines","Gunner McLovin","Harry Madison","Arnie Palmfrond","Jake Nicklelisp","William","Billy Bones","Jim Mulligan"]
    },
    633: {
        typeName: "Zoologist",
        town: true,
        names: ["Maria","MacKenzie","Azaria","Juanita","Astra","Hayley","Becca","Veronica","Tia","Robyn","Arien","Jane","Bindi","Dian","Lori","Mardy","Mollie","Lizzy","Daphne","Ellen"]
    },
    637: {
        typeName: "Cat",
        town: true,
        variations: ["Siamese","Black","OrangeTabby","RussianBlue","Silver","White"],
        names: [
            ["Zen","Callie","Rainha","Nust","Bandit","Goliath","Valerie","Socks","Iris","Sekhmet","Cleo","Sappho"],
            ["Luna","Figment","Ember","Damien","Snowball","Night","Misu","Magic","Tonic","Violet","Jaspers","Gargoyle","Lilith","Salem","Rascal","Bella","Odin","Jiji","Morgan","Arbus","Max","George"],
            ["Linkle","Remy","Lux","Sunny","Tigger","Callie","Sassy","Bob","Leo","Tiger","Caramel","Tony","Garfield","Hobbes","Charlie","Rascal","Critter","Adol"],
            ["Alexi","Ruby","Bubbles","Lexi","Prissy","Valery","Lucy","Pete","Jocelyn","Light","Lily","Starlight","Cobalt","Tilly","Rion","Momo"],
            ["Roo","Blaze","Rebus","Polo","Kelly","Kiva","Sooty","By-Tor","Merlin","Trudy","Nana","Ange","Kanako","Freya","Cloud","Cutie","Renne"],
            ["Misty","Storm","Angel","Vincent","Mr. Cat","Holly","Sam","Rory","Ichibi","Belle","Yuki","Ater","Snowdrop","Snowball","Reah"]
        ]
    },
    638: {
        typeName: "Dog",
        town: true,
        variations: ["Labrador","PitBull","Beagle","Corgi","Dalmation","Husky"],
        names: [
            ["Penny","Pebbles","Puppy","Monroe","Kittie","Buddy","Charlie","Trulte","Daisy","Calvin","Willow","Arthur","John","Bitsy","Mike","Sparky","Lucky"],
            ["Max","Dexter","Chomps","Bubba","Sampson","Spike","Ginger","Kona","Keith","Jazzy","Rex","Toshiro","Buster","Doug"],
            ["Zelda","Navi","Ali","Fred","Roxie","Milo","Copper","Darwin","Lieselotte","Wilma","Odie","Feena"],
            ["Bella","Ellie","Baxter","Oliver","Maya","Titus","Shino","Elizabeth","Victoria","Yona","Ammy","Charles","Estelle","Astro"],
            ["Spot","Suzy","Lucky","Marshall","Dotty","Pongo","Sapphire","Splat","Aurora","Akane","Firebug","Polka","Mizore"],
            ["Rosalie","Balto","Miska","Sky","Sasha","Zoey","Toya","Snowdog","Kayla","Hachiko","Indiana","Sven","Bullet","Comet","Ingrid","Dogi"]
        ]
    },
    656: {
        typeName: "Bunny",
        town: true,
        variations: ["White","Angora","Dutch","Flemish","Lop","Silver"],
        names: [
            ["Bunnicula","Ben","Roger","Skippy","Donnie","Alice","Presto","Shion","Lisette","Lily","Inaba","Shirayuki","Lilia",],
            ["Breadbuns","Loaf","Babs","Big B","Greg","Fluffy","Pom","Muffin","Maximus","Donald",],
            ["Oreo","Olaf","Domino","Oz","Yin","Yang","Pow","Kaguya","Mono","Panda","Orin"],
            ["Thumper","Cinnabun","Peter","Hazel","Loki","Sunflower","Toby","Daisy","Dusty","Jazz","Russell","Honeycomb"],
            ["Bunbun","Lola","Max","Tyler","Flops","Flappie","Caerbannog","Mochi","Dandy","Puff","Youp","Boof","Veidra"],
            ["Bugz","Buster","Silvine","Bunstar","Lord","Bunnykins","Crystal","Chrome","Vincent","Zach","Joshua","Dustbunny","Dusty"]
        ]
    },
    663: {
        typeName: "Princess",
        town: true,
        names: ["Ai","Hime","Emilia","Alice","Belle","Sophia","Hikari","Faye","Christina","Flora","Liselotte","Aria","Yuuki","Theresa","Elitia","Lucia","Ariel","Momo","Charlotte","Tiara","Rosetta"]
    },
    422: {
        typeName: "Vortex Pillar",
        pillar: true
    },
    493: {
        typeName: "Stardust Pillar",
        pillar: true
    },
    507: {
        typeName: "Nebula Pillar",
        pillar: true
    },
    517: {
        typeName: "Solar Pillar",
        pillar: true
    }
}